function safeId(value) {
  if (!value) return "";
  if (typeof value === "object" && value._id) return String(value._id);
  return String(value);
}

export function buildTreeFromFlat(flatList = []) {
  const nodes = (Array.isArray(flatList) ? flatList : []).map((n) => ({
    ...n,
    _id: safeId(n?._id),
    parentId: n?.parentId ? safeId(n.parentId) : "",
    children: [],
  }));

  const byId = new Map(nodes.map((n) => [n._id, n]));
  const roots = [];

  nodes.forEach((n) => {
    if (n.parentId && byId.has(n.parentId)) byId.get(n.parentId).children.push(n);
    else roots.push(n);
  });

  const sortFn = (a, b) => {
    const ao = Number(a?.sortOrder || 0);
    const bo = Number(b?.sortOrder || 0);
    if (ao !== bo) return ao - bo;
    return String(a?.label || "").localeCompare(String(b?.label || ""));
  };

  const sortDeep = (list) => {
    list.sort(sortFn);
    list.forEach((x) => sortDeep(x.children || []));
  };
  sortDeep(roots);

  return roots;
}

export function flattenTree(tree = []) {
  const out = [];
  const walk = (nodes, depth) => {
    (nodes || []).forEach((n) => {
      out.push({ node: n, depth });
      walk(n.children || [], depth + 1);
    });
  };
  walk(Array.isArray(tree) ? tree : [], 0);
  return out;
}

export function indexCategoryTree(tree = []) {
  const byId = new Map();
  const bySlug = new Map();
  const parentById = new Map();

  const walk = (nodes, parentId) => {
    (nodes || []).forEach((n) => {
      const id = safeId(n?._id);
      const slug = String(n?.slug || "").trim().toLowerCase();
      const pid = parentId ? String(parentId) : (n?.parentId ? safeId(n.parentId) : "");
      byId.set(id, n);
      if (slug) bySlug.set(slug, n);
      parentById.set(id, pid || "");
      walk(n.children || [], id);
    });
  };
  walk(Array.isArray(tree) ? tree : [], "");

  return { byId, bySlug, parentById };
}

export function collectDescendantIds(node) {
  const ids = [];
  const walk = (n) => {
    if (!n) return;
    const id = safeId(n._id);
    if (id) ids.push(id);
    (n.children || []).forEach(walk);
  };
  walk(node);
  return ids;
}

export function buildBreadcrumb(treeIndex, activeNode) {
  const crumbs = [];
  if (!treeIndex || !activeNode) return crumbs;
  const { parentById, byId } = treeIndex;
  let cur = activeNode;
  let guard = 0;
  while (cur && guard < 20) {
    crumbs.unshift(cur);
    const pid = parentById.get(safeId(cur._id));
    cur = pid ? byId.get(pid) : null;
    guard += 1;
  }
  return crumbs;
}

